import axios from 'axios';

const BASE  = process.env.REACT_APP_API_BASE_URL;
const TOKEN = process.env.REACT_APP_API_TOKEN;

const client = axios.create({
  baseURL: BASE,
  timeout: 30000,
});

async function parseBlobError(err) {
  const blob = err.response?.data;
  if (blob instanceof Blob && blob.type === 'application/json') {
    try {
      const text = await blob.text();
      err.response.data = JSON.parse(text);
    } catch {
      /* leave as-is */
    }
  }
  throw err;
}

export async function generatePoster(nomineeCode, imageFile) {
  const form = new FormData();
  form.append('nominee_code', nomineeCode);
  form.append('nominee_photo', imageFile);
  try {
    const res = await client.post(`/frontapi/posters/generate/${TOKEN}`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    });
    return res.data;
  } catch (err) {
    return parseBlobError(err);
  }
}

export async function generateAttendingPoster(attendeeName, imageFile) {
  const form = new FormData();
  form.append('attendee_name', attendeeName);
  form.append('attendee_photo', imageFile);
  try {
    const res = await client.post(`/frontapi/posters/generate-attending/${TOKEN}`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    });
    return res.data;
  } catch (err) {
    return parseBlobError(err);
  }
}
